import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const ancillaryFeesAPI = createApi({
    reducerPath: "ancillaryFeesAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAncillaryCharges: builder.query({
            query: () => {
                return {
                    url: '/bookings/ancillary-fees',
                    method: "GET"
                };
            },
            transformResponse: (response) => response,
            providesTags: ["ancillary-fees"],
        }),
        createAncillaryCharge: builder.mutation({
            query: ({ body }) => {
                return {
                    url: '/bookings/ancillary-fees',
                    method: "POST",
                    body
                };
            },
            transformResponse: (response) => response,
            invalidatesTags: ["ancillary-fees"],
        }),
        updateAncillaryCharge: builder.mutation({
            query: ({ id, body }) => {
                return {
                    url: `/bookings/ancillary-fees/${id}`,
                    method: "PUT",
                    body
                };
            },
            transformResponse: (response) => response,
            invalidatesTags: ["ancillary-fees"],
        })
    }),
});

export const { 
    useGetAncillaryChargesQuery,
    useCreateAncillaryChargeMutation,
    useUpdateAncillaryChargeMutation
} = ancillaryFeesAPI;

export default ancillaryFeesAPI;